import React, { useRef } from "react";
import { products } from "../../data";
import Card from "./Card";
import { motion, useScroll, useTransform } from "framer-motion";

const Work = () => {
  const container = useRef(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start start", "end end"],
  });

  return (
    <div className="px-2" ref={container} id="work">
      {products.map((item, index) => {
        const targetScale = 1 - (products.length - index) * 0.05;
        return (
          <Card
            key={index}
            index={index}
            {...item}
            targetScale={targetScale}
            progress={scrollYProgress}
            range={[(index * 100) / products.length / 100, 1]}
          />
        );
      })}
    </div>
  );
};

export default Work;
